// import gqmsUtils from '@/views/gqmsCommUtil/api'; //공통함수 import
import { rootComputed } from '@/store/common/helpers';
import { setLpad, setChartBgColor, setChartBdColor } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';

export default {
	dayCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let mmScn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001021')}`, //연료전지사양
			prop: 'mmScn',
			align: 'left',
			width: '120px',
			sortable: false
		};
		let scn = {
			label: '',
			prop: 'scn',
			align: 'left',
			width: '120px',
			sortable: false
		};
		let genTot = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001730')}`, //Total
			prop: 'genTot',
			align: 'left',
			minWidth: '100px',
			sortable: false
		};
		let gen01 = {
			label: 'Gen2A', //Gen2A
			prop: 'gen01',
			align: 'left',
			width: '120px',
			sortable: false
		};
		let gen02 = {
			label: 'Gen2AIP67', //Gen2AIP67
			prop: 'gen02',
			align: 'left',
			width: '120px',
			sortable: false
		};
		let gen03 = {
			label: 'Gen2C', //Gen2C
			prop: 'gen03',
			align: 'left',
			width: '120px',
			sortable: false
		};
		let gen04 = {
			label: 'Gen2CIP67', //Gen2CIP67
			prop: 'gen04',
			align: 'left',
			width: '120px',
			sortable: false
		};
		let gen05 = {
			label: 'ETC', //Gen2CIP67
			prop: 'gen05',
			align: 'left',
			width: '120px',
			sortable: false
		};

		cols.push(mmScn);
		cols.push(scn);
		cols.push(genTot);
		cols.push(gen01);
		cols.push(gen02);
		cols.push(gen03);
		cols.push(gen04);
		cols.push(gen05);

		return cols;
	},
	kdCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let partNo = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000956')}`, //품번
			prop: 'partNo',
			align: 'left',
			minWidth: '80px',
			sortable: false
		};
		let partNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000957')}`, //품명
			prop: 'partNm',
			align: 'left',
			minWidth: '80px',
			sortable: false
		};
		let phmnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001741')}`, //대표현상
			prop: 'phmnNm',
			align: 'left',
			minWidth: '80px',
			sortable: false
		};
		let cnt = {
			label: `${rootGetters['commonStore/getMessage_']('SWCC000572')}`, //건수
			prop: 'cnt',
			align: 'left',
			width: '120px',
			sortable: false
		};

		cols.push(partNo);
		cols.push(partNm);
		cols.push(phmnNm);
		cols.push(cnt);

		return cols;
	},
	LpCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let partNo = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000956')}`, //품번
			prop: 'partNo',
			align: 'left',
			minWidth: '80px',
			sortable: false
		};
		let partNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000957')}`, //품명
			prop: 'partNm',
			align: 'left',
			minWidth: '80px',
			sortable: false
		};
		let phmnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001741')}`, //대표현상
			prop: 'phmnNm',
			align: 'left',
			minWidth: '80px',
			sortable: false
		};
		let cnt = {
			label: `${rootGetters['commonStore/getMessage_']('SWCC000572')}`, //건수
			prop: 'cnt',
			align: 'left',
			width: '120px',
			sortable: false
		};

		cols.push(partNo);
		cols.push(partNm);
		cols.push(phmnNm);
		cols.push(cnt);

		return cols;
	},
	//바 차트 Label
	stackedLabel_: (state, getters, rootState, rootGetters) => {
		let flclSpcList = state.flclSpcList;
		let labelArray = [];

		for (let i = 0; i < flclSpcList.length; i++) {
			let Name = flclSpcList[i].commCdName;

			labelArray.push(Name);
		}

		return labelArray;
	},

	//바 차트 데이터
	stackedDataSet_: ({ grdList }) => {
		let cols = [];
		let gubun;
		let gen01;
		let gen02;
		let gen03;
		let gen04;
		let gen05;

		for (let i = 0; i < grdList.length; i++) {
			if (grdList[i].gubun == 3) {
				gubun = grdList[i].gubun;
				gen01 = grdList[i].gen01;
				gen02 = grdList[i].gen02;
				gen03 = grdList[i].gen03;
				gen04 = grdList[i].gen04;
				gen05 = grdList[i].gen05;

				let newCol = {
					type: 'bar',
					data: [gen01, gen02, gen03, gen04, gen05],
					dataKey: [gubun],
					backgroundColor: setChartBgColor(i)
					//borderColor: setChartBdColor(i),
					//borderWidth: 1
				};
				cols.push(newCol);
			}
		}
		return cols;
	},
	//도넛 차트 label
	doughnutLabel_: ({ pieList }) => {
		let labelArray = [];
		for (let i = 0; i < pieList.length; i++) {
			labelArray.push(pieList[i].partGNm);
		}
		return labelArray;
	},
	//도넛 차트 데이터
	doughnutDataSet_: ({ pieList }) => {
		let cols = [];

		let colsData = [];
		let bgColor = [];

		//데이터를 만든다.
		for (let i = 0; i < pieList.length; i++) {
			let cnt = pieList[i].cnt;
			colsData.push(cnt);
			bgColor.push(setChartBgColor(i));
		}

		let newCol = {
			data: colsData,
			backgroundColor: bgColor,
			borderColor: '#eee',
			hoverBorderColor: '#eee'
			//borderColor: setChartBdColor(i),
			//borderWidth: 1
		};

		cols.push(newCol);
		return cols;
	},
	//KD/LP 바 차트 Label
	stackedLabel3_: (state, getters, rootState, rootGetters) => {
		let labelArray = [];
		let tot = 'ToTal';
		let kd = 'KD';
		let lp = 'LP';

		labelArray.push(tot);
		labelArray.push(kd);
		labelArray.push(lp);

		return labelArray;
	},

	//KD/LP 바 차트 데이터
	stackedDataSet3_: ({ barList }) => {
		let cols = [];

		let kdCnt;
		let lpCnt;
		let totCnt;

		for (let i = 0; i < barList.length; i++) {
			totCnt = barList[i].totCnt;
			kdCnt = barList[i].kdCnt;
			lpCnt = barList[i].lpCnt;
			let rnum = barList[i].rnum;

			let newCol = {
				type: 'bar',
				data: [totCnt, kdCnt, lpCnt],
				dataKey: [rnum],
				backgroundColor: setChartBgColor(i)
				//borderColor: setChartBdColor(i),
				//borderWidth: 1
			};
			cols.push(newCol);
		}
		return cols;
	},
	chartlcYMaxVal_: state => {
		return Number(state.lcMaxVal);
	},
	chartBcYMaxVal_: state => {
		return Number(state.bcMaxVal);
	}
};
